import { useEffect, useReducer } from 'react'
import { MapContext } from './context'
import { mapReducer, initialMapState } from './reducers'
import { retrieveStoredButtonToggleOption, retrieveStoredFilterOption, retrieveStoredMapView } from '../utility/api'
import { toggleExpandedFilterButton, updateNonTeslaOnly, updateViewState } from './actions'

export default function MapStateProvider({ children, logIt = false }) {
	const [state, dispatch] = useReducer(mapReducer, initialMapState)
	useEffect(() => {
		const saved = retrieveStoredMapView()
		console.log('getting saved from stroage', saved)
		if (saved) dispatch(updateViewState(saved))
	}, [dispatch]
	)

	useEffect(() => {
		const bool = retrieveStoredFilterOption()
		dispatch(updateNonTeslaOnly(bool))
	}, [])

	useEffect(() => {
		const bool = retrieveStoredButtonToggleOption()
		dispatch(toggleExpandedFilterButton(bool))
	}, [])

	return (
		<MapContext.Provider value={[state, dispatch]}>
			{children}
		</MapContext.Provider>
	)
}
